import DateAdapter from "./DateAdapter";

export default class DateAdapterFactory {
    static createInstance(date) {
        return new DateAdapter(date);
    }
}